import { List, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MapLayers } from 'features/mapping/mapping.constants';
import { RadioTowerIcon } from 'features/mapping/icons';
import { LegendListItem } from './LegendListItem';
import { LegendSectionTitle } from './LegendSectionTitle';

export const RadioTowersLegend = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <List
      disablePadding
      dense
      subheader={
        <LegendSectionTitle>
          {t('map.legends.tactical.title')}
        </LegendSectionTitle>
      }
    >
      <LegendListItem
        mapLayer={MapLayers.RADIO_TOWERS}
        iconSrc={RadioTowerIcon.data}
        iconSize={26}
        primaryText={t('map.legends.tactical.legends.radioTower.title')}
        secondary={
          <Typography variant="body2">
            {t('map.legends.tactical.legends.radioTower.subtitle')}
          </Typography>
        }
        minMembership="pro"
      />
    </List>
  );
};
